import { render, staticRenderFns } from "./SocialShareModal.vue?vue&type=template&id=5431062f&scoped=true&"
import script from "./SocialShareModal.vue?vue&type=script&lang=js&"
export * from "./SocialShareModal.vue?vue&type=script&lang=js&"
import style0 from "./SocialShareModal.vue?vue&type=style&index=0&id=5431062f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431062f",
  null
  
)

export default component.exports